// import React, { useState, useRef } from 'react';
// import { useQuery, useMutation, useQueryClient } from 'react-query';
// import axios from 'axios';
// import {
//   Box,
//   Button,
//   Table,
//   Thead,
//   Tbody,
//   Tr,
//   Th,
//   Td,
//   VStack,
//   HStack,
//   Select,
//   Input,
//   AlertDialog,
//   AlertDialogBody,
//   AlertDialogFooter,
//   AlertDialogHeader,
//   AlertDialogContent,
//   AlertDialogOverlay,
//   Spinner,
//   Text,
//   useToast,
// } from '@chakra-ui/react';
// import Api from '../../api/ApiUrl';
// import CustomSpinner from '../EndedAuctions/CustomSpinner';



// const fetchChargingRequests = async ({ queryKey }) => {
//     const [, { page, status }] = queryKey;
//     const queryParams = new URLSearchParams();
  
//     queryParams.append('page', page);
//     if (status) {
//       queryParams.append('status', status);
//     }
  
//     const response = await axios.get(`${Api}/api/v1/walletcharge/charging-history?${queryParams.toString()}`);
//     return response.data;
//   };
  
// const updateChargingRequest = async ({ id, status, amount }) => {
//   const response = await axios.post(`${Api}/api/v1/walletcharge/review-wallet-charger`, { paymentId: id, status, amount });
//   return response.data;
// };

// const WalletChargerAdmin = () => {
//   const queryClient = useQueryClient();
//   const toast = useToast();

//   const [page, setPage] = useState(1);
//   const [status, setStatus] = useState('');
//   const [selectedRequest, setSelectedRequest] = useState(null);
//   const [isAlertOpen, setIsAlertOpen] = useState(false);
//   const [amount, setAmount] = useState('');
//   const cancelRef = useRef();

//   const onCloseAlert = () => {
//     setIsAlertOpen(false);
//     setAmount('');
//   };

//   const { data, isLoading, isError, error } = useQuery(['chargingRequests', { page, status }], fetchChargingRequests, {
//     keepPreviousData: true,
//   });

//   console.log(data)
//   const mutation = useMutation(updateChargingRequest, {
//     onSuccess: () => {
//       queryClient.invalidateQueries('chargingRequests');
//       toast({
//         title: 'Request updated.',
//         description: 'The wallet charging request has been updated successfully.',
//         status: 'success',
//         duration: 3000,
//         isClosable: true,
//       });
//       onCloseAlert();
//     },
//     onError: (error) => {
//       toast({
//         title: 'An error occurred.',
//         description: error.response?.data?.message || 'Unable to update the wallet charging request.',
//         status: 'error',
//         duration: 3000,
//         isClosable: true,
//       });
//     },
//   });

//   const handleUpdate = (status) => {
//     if (status === 'completed' && !amount) {
//       toast({
//         title: 'Amount required.',
//         description: 'Please enter the amount to complete the request.',
//         status: 'warning',
//         duration: 3000,
//         isClosable: true,
//       });
//       return;
//     }
//     if (selectedRequest) {
//       mutation.mutate({ id: selectedRequest._id, status, amount });
//     }
//   };
//   if(isLoading) {

//     return <CustomSpinner/>
// }
//   return (
//     <Box p={4}>
//       <VStack spacing={4} width="100%">
//         <HStack spacing={4} width="100%">
//           <Select placeholder="Filter by Status" onChange={(e) => setStatus(e.target.value)}>
//             <option value="pending">Pending</option>
//             <option value="completed">Completed</option>
//             <option value="rejected">Rejected</option>
//           </Select>
//           <Input
//             placeholder="Page"
//             type="number"
//             value={page}
//             onChange={(e) => setPage(Number(e.target.value))}
//           />
//         </HStack>
//         {isLoading ? (
//           <Spinner size="xl" />
//         ) : isError ? (
//           <Text color="red.500">Error: {error.message}</Text>
//         ) : (
//           <Table>
//             <Thead>
//               <Tr>
//                 {/* <Th>User ID</Th> */}
//                 <Th>Billing Method</Th>
//                 <Th>Status</Th>
//                 <Th>Amount</Th>
//                 <Th>Actions</Th>
//               </Tr>
//             </Thead>
//             <Tbody>
//               {data?.data?.data?.map((request) => (
//                 <Tr key={request._id}>
//                   {/* <Td>{request.userId}</Td> */}
//                   <Td>{request.billingMethod}</Td>
//                   <Td>{request.status}</Td>
//                   <Td>{request.amount}</Td>
//                   <Td>
//                     <Button
//                       colorScheme="green"
//                       onClick={() => {
//                         setSelectedRequest(request);
//                         setIsAlertOpen(true);
//                       }}
//                     >
//                       Review
//                     </Button>
//                   </Td>
//                 </Tr>
//               ))}
//             </Tbody>
//           </Table>
//         )}
//         <AlertDialog
//           isOpen={isAlertOpen}
//           leastDestructiveRef={cancelRef}
//           onClose={onCloseAlert}
//         >
//           <AlertDialogOverlay>
//             <AlertDialogContent>
//               <AlertDialogHeader fontSize="lg" fontWeight="bold">
//                 Review Charging Request
//               </AlertDialogHeader>
//               <AlertDialogBody>
//                 Are you sure you want to approve or reject this charging request?
//                 {selectedRequest?.status === 'pending' && (
//                   <Input
//                     placeholder="Amount"
//                     type="number"
//                     mt={4}
//                     value={amount}
//                     onChange={(e) => setAmount(e.target.value)}
//                   />
//                 )}
//               </AlertDialogBody>
//               <AlertDialogFooter>
//                 <Button ref={cancelRef} onClick={onCloseAlert}>
//                   Cancel
//                 </Button>
//                 <Button
//                   colorScheme="green"
//                   onClick={() => handleUpdate('completed')}
//                   ml={3}
//                 >
//                   Approve
//                 </Button>
//                 {/* <Button
//                   colorScheme="red"
//                   onClick={() => handleUpdate('rejected')}
//                   ml={3}
//                 >
//                   Reject
//                 </Button> */}
//               </AlertDialogFooter>
//             </AlertDialogContent>
//           </AlertDialogOverlay>
//         </AlertDialog>
//       </VStack>
//     </Box>
//   );
// };

// export default WalletChargerAdmin;









import React, { useState, useRef } from 'react';
import { useQuery, useMutation, useQueryClient } from 'react-query';
import axios from 'axios';
import {
  Box,
  Button,
  Table,
  Thead,
  Tbody,
  Tr,
  Th,
  Td,
  VStack,
  HStack,
  Select,
  Input,
  Modal,
  ModalOverlay,
  ModalContent,
  ModalHeader,
  ModalFooter,
  ModalBody,
  ModalCloseButton,
  Spinner,
  Text,
  useToast,
  useDisclosure,
  Image
} from '@chakra-ui/react';
import Api from '../../api/ApiUrl';
import CustomSpinner from '../EndedAuctions/CustomSpinner';
const config = {
  headers: {
      // Authorization: `Bearer ${Cookies.get('token')}`,
      role: 'admin'
  },
};
const fetchChargingRequests = async ({ queryKey }) => {
  const [, { page, status, phoneNumber }] = queryKey;
  const queryParams = new URLSearchParams();

  queryParams.append('page', page);
  if (status) {
    queryParams.append('status', status);
  }
  if (phoneNumber) {
    queryParams.append('phoneNumber', phoneNumber);
  }

  const response = await axios.get(`${Api}/api/v1/walletcharge/charging-history?${queryParams.toString()}`,config);
  return response.data;
};

const updateChargingRequest = async ({ id, status, amount }) => {
  const response = await axios.post(`${Api}/api/v1/walletcharge/review-wallet-charger`, { paymentId: id, status, amount },config);
  return response.data;
};

const WalletChargerAdmin = () => {
  const queryClient = useQueryClient();
  const toast = useToast();
  const { isOpen, onOpen, onClose } = useDisclosure();
  const cancelRef = useRef();

  const [page, setPage] = useState(1);
  const [status, setStatus] = useState('');
  const [phoneNumber, setPhoneNumber] = useState('');
  const [selectedRequest, setSelectedRequest] = useState(null);
  const [amount, setAmount] = useState('');

  const { data, isLoading, isError, error, refetch } = useQuery(['chargingRequests', { page, status, phoneNumber }], fetchChargingRequests, {
    keepPreviousData: true,
  });

  const mutation = useMutation(updateChargingRequest, {
    onSuccess: () => {
      queryClient.invalidateQueries('chargingRequests');
      toast({
        title: 'Request updated.',
        description: 'The wallet charging request has been updated successfully.',
        status: 'success',
        duration: 3000,
        isClosable: true,
      });
      onClose();
    },
    onError: (error) => {
      toast({
        title: 'An error occurred.',
        description: error.response?.data?.message || 'Unable to update the wallet charging request.',
        status: 'error',
        duration: 3000,
        isClosable: true,
      });
    },
  });

  const handleUpdate = (status) => {
    if (status === 'completed' && !amount) {
      toast({
        title: 'Amount required.',
        description: 'Please enter the amount to complete the request.',
        status: 'warning',
        duration: 3000,
        isClosable: true,
      });
      return;
    }
    if (selectedRequest) {
      mutation.mutate({ id: selectedRequest._id, status, amount });
    }
  };

  const openReviewModal = (request) => {
    setSelectedRequest(request);
    setAmount(request.amount || '');
    onOpen();
  };

  const handleSearch = () => {
    refetch();
  };

  if (isLoading) {
    return <CustomSpinner />;
  }

  return (
    <Box p={4}>
      <VStack spacing={4} width="100%">
        <HStack spacing={4} width="100%">
          <Select placeholder="Filter by Status" onChange={(e) => setStatus(e.target.value)}>
            <option value="pending">Pending</option>
            <option value="completed">Completed</option>
            <option value="rejected">Rejected</option>
          </Select>
          <Input
            placeholder="Page"
            type="number"
            value={page}
            onChange={(e) => setPage(Number(e.target.value))}
          />
          {/* <Input
            placeholder="Search by Phone Number"
            value={phoneNumber}
            onChange={(e) => setPhoneNumber(e.target.value)}
          /> */}
          {/* <Button onClick={handleSearch} colorScheme="teal">Search</Button> */}
        </HStack>
        {isLoading ? (
          <Spinner size="xl" />
        ) : isError ? (
          <Text color="red.500">Error: {error.message}</Text>
        ) : (
          <Table>
            <Thead>
              <Tr>
                <Th>Billing Method</Th>
                <Th>User Name</Th>
                <Th>Phone Number</Th>
                <Th>Status</Th>
                <Th>Amount</Th>
                <Th>Created At</Th>
                <Th>Actions</Th>

              </Tr>
            </Thead>
            <Tbody>
              {data?.data?.data?.map((request) => (
                <Tr key={request?._id}>
                  <Td>{request?.billingMethod}</Td>
                  <Td>{request?.userId?.name}</Td>
                  <Td>{request?.userId?.phoneNumber}</Td>
                  <Td>{request?.status}</Td>
                  <Td>{request?.amount}</Td>
                  <Td>  {new Date(request?.createdAt).toLocaleString()}</Td>

                
                  <Td>
                    <Button
                      colorScheme="green"
                      onClick={() => openReviewModal(request)}
                    >
                      Review
                    </Button>
                  </Td>
                </Tr>
              ))}
            </Tbody>
          </Table>
        )}

        <Modal size={'xl'} isOpen={isOpen} onClose={onClose}>
          <ModalOverlay />
          <ModalContent>
            <ModalHeader>Review Charging Request</ModalHeader>
            <ModalCloseButton />
            <ModalBody>
              {selectedRequest && (
                <>
                  <Text><strong>User Name:</strong> {selectedRequest?.userId?.name}</Text>
                  <Text><strong>Billing Method:</strong> {selectedRequest?.billingMethod}</Text>
                  <Text><strong>Status:</strong> {selectedRequest?.status}</Text>
                  <Text><strong>Amount:</strong> {selectedRequest?.amount}</Text>
                  <Image
                    src={`${Api}/${selectedRequest?.billImage?.path}`}
                    alt="Bill Image"
                    mt={4}
                    boxSize="500px"
                    objectFit="cover"
                  />
                  {selectedRequest?.status === 'pending' && (
                    <Input
                      placeholder="Amount"
                      type="number"
                      mt={4}
                      value={amount}
                      onChange={(e) => setAmount(e.target.value)}
                    />
                  )}
                </>
              )}
            </ModalBody>
            <ModalFooter>
              <Button ref={cancelRef} onClick={onClose}>
                Cancel
              </Button>
              {selectedRequest?.status === 'pending' && (
                <Button
                  colorScheme="green"
                  onClick={() => handleUpdate('completed')}
                  ml={3}
                >
                  Approve
                </Button>
              )}
            </ModalFooter>
          </ModalContent>
        </Modal>
      </VStack>
    </Box>
  );
};

export default WalletChargerAdmin;
